module.exports = __webpack_public_path__ + "img/pozar.323cd3d1.jpeg";